import { ManageListActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/ManageListActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionController';
import { DistributionList } from 'modules/distributionList/DistributionList';
import '../Actions.scss';
const ACTION_UNDO_REDO_CHANGES = 'actions_undoredo_changes';
export class ManageListActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', 'DistributionListService', 'CurrentApplicationService', 'CacheService', '$translate', '$rootScope', 'UndoRedoService', 'state', 'ngToast', '$scope', 'typeOfAction', 'onOpenSchemaEditor'];
    constructor(close, action, $onStateChanged, DistributionListService, CurrentApplicationService, CacheService, $translate, $rootScope, UndoRedoService, state, ngToast, $scope, typeOfAction, onOpenSchemaEditor) {
        super(close, action, $onStateChanged, UndoRedoService, state, { $rootScope, $scope, typeOfAction, onOpenSchemaEditor });
        this.DistributionListService = DistributionListService;
        this.CurrentApplicationService = CurrentApplicationService;
        this.CacheService = CacheService;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.ngToast = ngToast;
        this.distributionLists = [];
        this.listOptions = [];
        this.loading = true;
        this.isEditing = false;
        this.init();
        this.setOptions();
    }
    setOptions() {
        this.addNewListText = {
            text: this.$translate.instant('builder-tabs-actions.manageList.addOption'),
        };
        const addOption = this.$translate.instant('builder-tabs-actions.manageList.add');
        const removeOption = this.$translate.instant('builder-tabs-actions.manageList.remove');
        this.actionOptions = [
            {
                label: addOption,
                value: 'Add',
            },
            {
                label: removeOption,
                value: 'Remove',
            },
        ];
    }
    create() {
        return new ManageListActionSettings();
    }
    onBlur() {
        this.isEditing = false;
        if (this.$title.length === 0) {
            this.$title = this.$translate.instant('builder-tabs-actions.manageList.title');
            this.save();
        }
    }
    startEditing() {
        const input = document.getElementById('distribution-list-title');
        if (input) {
            input.focus();
        }
    }
    async init() {
        this.loading = true;
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
        try {
            this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
            this.updateSelectNameList();
            const responseCommand = await this.CacheService.getOrAdd(this.listCacheKey, () => this.DistributionListService.getDistributionLists(), this.cacheExpirationTimeInMilliseconds);
            const items = responseCommand.items;
            this.distributionLists = items
                .filter((l) => !l.endsWith('+senders@broadcast.msging.net'))
                .map((identity) => DistributionList.createDistributionList(identity, this.application));
            this.listOptions = this.distributionLists.map((el) => ({
                label: el.name,
                value: el.name,
            }));
        }
        catch (err) {
            console.error(err);
        }
        finally {
            this.loading = false;
        }
        this.$rootScope.$on(ACTION_UNDO_REDO_CHANGES, () => {
            this.updateSelectNameList();
        });
        document.querySelector('.sidebar-default-form #manage-list-action')
            ?.addEventListener('bdsChange', ({ detail: { value } }) => this.bdsSelectChanged(value));
    }
    get cacheExpirationTimeInMilliseconds() {
        return 30000;
    }
    get listCacheKey() {
        return `${this.application.shortName}:lists`;
    }
    bdsSelectChanged(value) {
        this.action.settings.action = value;
        this.save();
    }
    updateSelectNameList() {
        this.selectedDistributionList = this.action.settings.listName
            ? DistributionList.createDistributionList(this.action.settings.listName, this.application)
            : undefined;
        this.currentList = this.selectedDistributionList
            ? this.selectedDistributionList.name
            : '';
        this.saveDistributionList();
    }
    async onSelectOption(value) {
        this.currentList = value;
        await this.onListSelected();
    }
    async onListSelected() {
        this.selectedDistributionList = this.distributionLists.find((list) => list.name === this.currentList);
        await this.save();
    }
    async addNewOptionToList(label) {
        const newList = DistributionList.createDistributionList(label, this.application);
        this.currentList = label;
        newList.stored = false;
        this.selectedDistributionList = newList;
        this.listOptions = this.distributionLists.map((el) => ({
            label: el.name,
            value: el.name,
        }));
        await this.save();
        const items = this.distributionLists
            .reduce((accumulator, currentOption) => accumulator = [...accumulator, currentOption.name], [])
            .sort();
        this.CacheService.add(this.listCacheKey, { items }, this.cacheExpirationTimeInMilliseconds);
    }
    async save() {
        try {
            await this.saveDistributionList();
            await super.save();
        }
        catch (error) {
            console.error(error);
            this.selectedDistributionList = undefined;
            this.currentList = '';
            const errorMsg163 = await this.$translate('utils.errorMsg.164');
            this.ngToast.danger(errorMsg163);
        }
    }
    async saveDistributionList() {
        this.action.settings.listName = this.selectedDistributionList
            ? DistributionList.toIdentity(this.selectedDistributionList, this.application)
            : undefined;
        if (this.selectedDistributionList &&
            !this.selectedDistributionList.stored) {
            try {
                await this.DistributionListService.setDistributionList(DistributionList.toIdentity(this.selectedDistributionList, this.application));
                this.selectedDistributionList.stored = true;
                this.distributionLists.push(this.selectedDistributionList);
                this.listOptions.push({
                    label: this.selectedDistributionList.name,
                    value: this.selectedDistributionList.name,
                });
            }
            catch (error) {
                this.currentList = '';
                this.onListSelected();
                console.error(error);
                throw new Error();
            }
        }
    }
}
ManageListActionController.$inject = ['close', 'action', '$onStateChanged', 'DistributionListService', 'CurrentApplicationService', 'CacheService', '$translate', '$rootScope', 'UndoRedoService', 'state', 'ngToast', '$scope', 'typeOfAction', 'onOpenSchemaEditor'];
